module.exports = __webpack_public_path__ + "static/media/DBHeaventNow.299e7eba.ttf";